import { PropagateLoader } from "react-spinners";

function Loading () {
  return (
    <span className='flex justify-center mt-2 mb-8 md:mt-14'><PropagateLoader color="#36d7b7" /></span>
  )
}

export default Loading;